module.exports = __webpack_public_path__ + "assets/measure_vehicle_condition.47ab50fc.svg";